import React, { Component } from 'react'
import { Icon, Menu, ActivityIndicator } from 'antd-mobile';
import { CommonlyHead } from '../common/headnav';
import { Footer } from '../common/footerbar';
import * as services from '../projects/services';
import * as fun from '../../components/common';
import imgURL from '../../res/images/logo.png';
import { HospitalItems } from './item';
import '../hospital/style.less';
import "../../utils/tool.jsx";
let page = 1;
let rows = 10;
let total = 0;
let firstShow = true;

let parameter = {
    page: page, //：页码
    rows: rows, //每页条数
    level: '',//医院等级 –查询条件
    county: '', //区域名称
    isenable: '',  //是否联盟: 1是，其他否
    city: '',
}
let levelData = [{ value: '0', label: '全部' }];
let countyData = [{ value: '0', label: '全部' }];
let enableData = [{ value: '-1', label: '全部' }];
export default class HospitalList extends Component {
    constructor(props) {
        super(props);

        if (!window.globalvariable.getStore('cityid')) {
            window.globalvariable.setStore('cityid', global.constants.cityid);
        }
         page = 1;
         rows = 10;
         total = 0;
         firstShow = true;
          levelData = [{ value: '0', label: '全部' }];
          countyData = [{ value: '0', label: '全部' }];
          enableData = [{ value: '-1', label: '全部' }];
        parameter = {
            page: page, //：页码
            rows: rows, //每页条数
            level: '',//医院等级 –查询条件
            county: '', //区域名称
            isenable: '',  //是否联盟: 1是，其他否
            city: window.globalvariable.getStore('cityid'),
        }
        this.state =
            {
                show: false,
                parameter: parameter,
                item: '',
                hospitalListDatas: [],
                levelData: levelData,
                countyData: countyData,
                enableData: enableData,
                levelC: 0,
                countyC: 0,
                enableC: 0,
                levelCname: '医院等级',
                countyCname: '体检区域',
                enableCname: '是否联盟',
            }
    }
    //页面初渲染时
    componentDidMount() {
       // let url = global.constants.wx_tijian + this.props.match.url;
        let url=global.constants.wx_tijian + this.props.match.url;
        fun.wxshare(url, '优质体检中心推荐-全人·健康', '全人·健康检联体联盟体检中心推荐。', imgURL);
        this.GetPageMidcailCenter();
        this.GetList('等级');
        this.GetList('是否联盟');
        this.GetListbycode();
        const wrapper = this.refs.wrapper;
        const loadMoreDataFn = this.loadMoreDataFn;
        let timeCount;
        function callback() {
            const top = wrapper.getBoundingClientRect().top;
            const windowHeight = window.screen.height;
            if (top && top < windowHeight + 1 && total / rows >= page) {
                page++;
                loadMoreDataFn(page);
            }
        }
        window.addEventListener('scroll', function () {
            if (this.state.isLoadingMore) {
                return;
            }
            if (timeCount) {
                clearTimeout(timeCount);
            }

            timeCount = setTimeout(callback, 50);
        }.bind(this), false);
    }

    //再次加载
    loadMoreDataFn = (page) => {
        parameter.page = page;
        this.setState({
            parameter: parameter,
        });
        services.GetPageMidcailCenter(this.state.parameter, '正在查询，请稍后').then(value => {
            this.setState({
                hospitalListDatas: this.state.hospitalListDatas.concat(value.result.rows),
            });
        })
    }
    //获取体检中心列表
    // //获取医院列表
    GetPageMidcailCenter = () => {
        services.GetPageMidcailCenter(this.state.parameter, '正在查询，请稍后').then(value => {
            if (value.status === 0) {
                total = value.result.total;
                this.setState({ hospitalListDatas: value.result.rows, }, () => {
                    firstShow = false;
                });
            }

        })
    }
    //获取区域
    GetListbycode = () => {

        services.GetListbycode(window.globalvariable.getStore('cityid'), '').then(value => {
            value.result.forEach(element => {
                countyData.push({ value: element.countyCode, label: element.countyName });
            })
        })
    }
    //获取医院等级 是否联盟
    GetList = (typename) => {
        services.GetList(typename, false).then(level => {
            level.result.forEach(element => {
                if (typename === '等级') {
                    levelData.push({ value: element.code, label: element.name });
                } else if (typename === '是否联盟') {
                    enableData.push({ value: element.code, label: element.name });
                }

            });
        })
    }

    levelClick = (e) => {
        window.scrollTo(0, 0);
        e.preventDefault();
        this.setState({
            item: 'level'
        });
        if (this.state.style !== 1) {
            this.setState({
                show: true,
                style: 1,
            });
        } else {
            this.setState({
                show: false,
                style: 0,
            });
        }
    }
    countyClick = (e) => {
        window.scrollTo(0, 0);
        e.preventDefault();
        this.setState({
            item: 'county'
        });
        if (this.state.style !== 2) {
            this.setState({
                show: true,
                style: 2,
            });
        } else {
            this.setState({
                show: false,
                style: 0,
            });
        }
    }
    enableClick = (e) => {
        window.scrollTo(0, 0);
        e.preventDefault();
        this.setState({
            item: 'enable'
        });
        if (this.state.style !== 3) {
            this.setState({
                show: true,
                style: 3,
            });
        } else {
            this.setState({
                show: false,
                style: 0,
            });
        }
    }
    //取消选择
    onCancel = () => {
        this.setState({
            show: false,
            style: 0,
        });
    }
    onOK = (value, evalue) => {
        parameter.page = 1;
        if (value === 1) {
            if (parseInt(evalue[0]) === 0) {
                parameter.level = '';
                this.setState({
                    parameter: parameter, levelCname: '医院等级'
                });

            } else {
                parameter.level = evalue;
                this.setState({
                    parameter: parameter, levelCname: this.state.levelData[parseInt(evalue[0])].label
                });
            }
            this.setState({ levelC: evalue });
        } else if (value === 2) {

            if (parseInt(evalue[0]) === 0) {
                parameter.county = '';
                this.setState({
                    parameter: parameter, countyCname: '体检区域'
                });

            } else {
                parameter.county = evalue;
                var cdata = this.state.countyData.find((value) => {
                    return value.value === evalue[0]
                });
                this.setState({
                    parameter: parameter, countyCname: cdata.label
                });
            }
            this.setState({ countyC: evalue });
        }
        else if (value === 3) {

            if (parseInt(evalue[0]) === -1) {
                parameter.isenable = '';
                this.setState({
                    parameter: parameter, enableCname: '是否联盟'
                });

            } else {
                parameter.isenable = evalue;
                this.setState({
                    parameter: parameter, enableCname: this.state.enableData[parseInt(evalue[0]) + 1].label
                });
            }
            this.setState({ enableC: evalue });
        }
        this.onCancel();
        page = 1;
        this.GetPageMidcailCenter();
    }
    render() {
        const { levelData, countyData, enableData, show, item } = this.state;
        var menuEl;
        var initData;

        if (item === "level") {
            initData = levelData;
            menuEl = (
                <Menu
                    className="single-foo-menu"
                    data={levelData}
                    value={this.state.levelC}
                    level={0}
                    onChange={this.onOK.bind(this, 1)}
                    height={document.documentElement.clientHeight * 0.6}
                />
            );
        } else if (item === "county") {
            initData = countyData;
            menuEl = (
                <Menu
                    className="single-foo-menu"
                    data={countyData}
                    value={this.state.countyC}
                    level={0}
                    onChange={this.onOK.bind(this, 2)}
                    height={document.documentElement.clientHeight * 0.6}
                />
            );
        } else if (item === "enable") {
            initData = enableData;
            menuEl = (
                <Menu
                    className="single-foo-menu"
                    data={enableData}
                    value={this.state.enableC}
                    level={0}
                    onChange={this.onOK.bind(this, 3)}
                    height={document.documentElement.clientHeight * 0.6}
                />
            );
        }
        const loadingEl = (
            <div style={{ position: 'absolute', width: '100%', height: document.documentElement.clientHeight * 0.6, display: 'flex', justifyContent: 'center' }}>
                <ActivityIndicator size="large" />
            </div>
        );

        return (
            <div className="hospital">
                <div className={show ? 'single-menu-active' : ''}>
                    <CommonlyHead barname="体检中心" />
                    <div className="filterbox">
                        <div className='filter'>
                            <div className="filter-item" key="1" onClick={this.levelClick} ><div style={{ color: this.state.style !== 1 ? '' : '#2fb992' }}>
                                <span>{this.state.levelCname}</span><Icon type={this.state.style !== 1 ? 'down' : 'up'} size="xxs" /></div></div>
                            <div className="filter-item" key="2" onClick={this.countyClick}><div style={{ color: this.state.style !== 2 ? '' : '#2fb992' }}>
                                <span>{this.state.countyCname}</span><Icon type={this.state.style !== 2 ? 'down' : 'up'} size="xxs" /></div></div>
                            <div className="filter-item" key="3" onClick={this.enableClick}><div style={{ color: this.state.style !== 3 ? '' : '#2fb992' }}>
                                <span>{this.state.enableCname}</span><Icon type={this.state.style !== 3 ? 'down' : 'up'} size="xxs" /></div></div>
                        </div>
                    </div>
                    {show ? initData ? menuEl : loadingEl : null}
                    {show ? <div className="menu-mask" onClick={this.onCancel} /> : null}
                    {total === 0 && firstShow === false ?
                        <div className="errordiv"><img alt='' src={require('../../res/images/zwsj.png')} />
                            <p>对不起，没有找到您要的信息，请重新筛选</p>
                        </div>
                        : ''}
                    <div className="itemlist">
                        {this.state.hospitalListDatas.map((data, index) => (<HospitalItems hospitalData={data} key={index} />))}
                        <div ref="wrapper"></div>
                    </div>
                    <Footer selectedTab="hospital" />
                </div>
            </div>);
    }
}